<template>
  <Layout
    v-if="mainMenuPage"
    :heading-text="headingText"
    class="MainMenuView"
    :subheading-text="mainMenuPage.subheading_text"
  >
    <CardList
      v-if="list.length"
      :list="list"
      class=""
    />
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import CardList from '@/components/CardList.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',

  components: {
    Layout,
    CardList
  },

  computed: {
    ...mapGetters([
      'mainMenuPage',
      'aoiPage',
      'guidedTourPage',
      'justExplorePage',
      'myStore'
    ]),
    // Page Content
    headingText() { return (this.mainMenuPage || {}).heading_text || this.mainMenuPage.title },
    list() {
      const { aoiPage, guidedTourPage, justExplorePage } = this
      const navMethodPages = []
      // Area of Interest
      const areaOfInteresEnabled = this.myStore(['settings', 'areas_of_interest_enabled']) ?? false
      if (aoiPage && areaOfInteresEnabled) { navMethodPages.push(aoiPage) }
      // Guided tour
      const guidedTourEnabled = this.myStore(['settings', 'guided_tour_enabled']) ?? false
      if (guidedTourPage && guidedTourEnabled) { navMethodPages.push(guidedTourPage) }
      // Just explore
      if (justExplorePage) { navMethodPages.push(justExplorePage) }
      return navMethodPages
    }
  },

  created() {
    this.$store.commit('pageMeta', { pageTitle: this.mainMenuPage.title })
  }
}
</script>

